export default "__VITE_ASSET__C$dACb13__"